import { Form, InputNumber, Row, Col, Divider } from 'antd';
import React from 'react';

const TaxesAndRetentions = () => {


  return (
    <>
      <Divider orientation="left">Impuestos y Retenciones</Divider>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="gravada21" label="Grav. 21%">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="iva21" label="Iva 21">
            <InputNumber style={{ width: '100%' }} min={0} disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="retGan" label="Ret Ganan.">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="gravada105" label="Grav. 10.5%">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="iva105" label="Iva 10.5">
            <InputNumber style={{ width: '100%' }} min={0} disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="retIva" label="Ret IVA">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="gravada27" label="Grav. 27%">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="iva27" label="Iva 27">
            <InputNumber style={{ width: '100%' }} min={0} disabled />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="retIIBB" label="Ret IIBB">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="percIB" label="Perc IB">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="percIva" label="Perc IVA">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="exento" label="Exento">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="cantidad" label="Cantidad">
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default TaxesAndRetentions;
